/**
 * AppErrorBoundary — последняя линия обороны для всего сайта.
 *
 * Без неё любая необработанная ошибка рендера выносит React-дерево целиком,
 * и пользователь видит пустую белую страницу — неотличимо от «сайт умер».
 * Так уже случалось с 3D-превью аватара: падение GLTFLoader роняло весь
 * кабинет вместе с WebGL-контекстом.
 *
 * Ставится ВЫШЕ провайдеров (Auth, Cabinet, Router), чтобы поймать и их
 * собственные падения. Поэтому стили — инлайновые: на момент ошибки CSS
 * приложения может быть ещё не загружен.
 */
import React from "react";

export default class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    console.error("Сбой интерфейса:", error, info?.componentStack);
  }

  render() {
    if (!this.state.failed) return this.props.children;

    return (
      <div style={S.wrap}>
        <div style={S.card}>
          <h1 style={S.title}>Что-то сломалось</h1>
          <p style={S.text}>
            Страница не смогла отрисоваться. Твои данные в порядке — они
            хранятся на сервере, ничего не потерялось.
          </p>
          <div style={S.actions}>
            <button
              type="button"
              style={S.primary}
              onClick={() => window.location.reload()}
            >
              Обновить страницу
            </button>
            <a href="/" style={S.ghost}>
              На главную
            </a>
          </div>
        </div>
      </div>
    );
  }
}

/* ⚠️ Цвета здесь НАМЕРЕННО захардкожены, а не взяты из токенов.
   Эта граница рисуется, когда приложение уже упало — в том числе если
   падение случилось до загрузки CSS или в самих провайдерах. Сошлись бы
   на var(--paper) — при сбое стилей получили бы чёрный текст на чёрном
   фоне, то есть пустой экран вместо объяснения.
   Не переводить на токены при общей унификации стилей. */
const S = {
  wrap: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 20,
    background: "#0b1226",
    fontFamily: "system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif",
  },
  card: {
    maxWidth: 460,
    width: "100%",
    padding: "32px 28px",
    borderRadius: 18,
    background: "#131c36",
    border: "1px solid #22304f",
    color: "#e6ecff",
    textAlign: "center",
  },
  title: { margin: "0 0 12px", fontSize: 22, fontWeight: 800 },
  text: { margin: "0 0 22px", fontSize: 15, lineHeight: 1.55, color: "#b9c5ec" },
  actions: {
    display: "flex",
    gap: 10,
    justifyContent: "center",
    flexWrap: "wrap",
  },
  primary: {
    padding: "11px 20px",
    borderRadius: 10,
    border: "none",
    background: "#3357ff",
    color: "#fff",
    fontWeight: 700,
    fontSize: 14,
    cursor: "pointer",
  },
  ghost: {
    padding: "11px 18px",
    borderRadius: 10,
    border: "1px solid #22304f",
    color: "#b9c5ec",
    fontWeight: 600,
    fontSize: 14,
    textDecoration: "none",
  },
};
